import React, { createContext } from "react";
import axios from "../utils/axios";

const initialState = {};

const LogContext = createContext({
  ...initialState,
  getLogs: () => Promise.resolve(),
});

function LogProvider({ children }) {
  const getLogs = async (ip, username) => {
    try {
      const response = await axios.get(`/logs/filter?ip=${ip}&username=${username}`);
      let logData = [];
      if (Array.isArray(response.data)) {
        logData = response.data;
      } else if (response.data && Array.isArray(response.data.data)) {
        logData = response.data.data;
      }
      return logData;
    } catch (error) {
      console.error("Error fetching logs:", error);
      throw error;
    }
  };

  return (
    <LogContext.Provider
      value={{
        getLogs,
      }}
    >
      {children}
    </LogContext.Provider>
  );
}

export { LogContext, LogProvider };
